const plazaTabsRegExp = /plaza_list\/.+\/(details|monitoring|realTimePower|editor)/;
const dashboardRegExp = /dashboard(.*)/;

export const shouldClearAdvancedSearchStateOnRouteChange = (previousPathname, pathname) => {
  const isLeavingPlaza = previousPathname.includes('plaza_list') && !plazaTabsRegExp.test(pathname);
  const isLeavingDashboard = dashboardRegExp.test(previousPathname) && !(pathname.includes('/chargers/edit/') || dashboardRegExp.test(pathname));
  const isGoingBackFromChargerEditToDashboard = previousPathname.includes('chargers/edit') && dashboardRegExp.test(pathname);
  const isLeavingChargers = previousPathname.includes('chargers') && !pathname.includes('chargers') && !isGoingBackFromChargerEditToDashboard;

  return isLeavingPlaza || isLeavingDashboard || isLeavingChargers;
};

export const shouldNotClearDashboardStateOnRouteChange = (previousPathname, pathname) => {
  const isGoingBackFromChargerEditToDashboard = previousPathname.includes('chargers/edit') && dashboardRegExp.test(pathname);
  const isGoingFromDashboardToChargersEdit = pathname.includes('chargers/edit') && dashboardRegExp.test(previousPathname);
  const isStayingOnDashboard = dashboardRegExp.test(previousPathname) && dashboardRegExp.test(pathname);

  return isGoingBackFromChargerEditToDashboard || isGoingFromDashboardToChargersEdit || isStayingOnDashboard;
};
